import React from 'react';

export default function BrowserNotSupported() {
  return (
    <div className="section">
      <div className="container">
        <article className="message is-danger">
          <div className="message-header">
            <p><strong>Sorry</strong>! This browser is not supported</p>
          </div>
          <div className="message-body">
            Our recommendation is to use the latest version of <a href="https://www.google.com/chrome/">Google Chrome</a>. Otherwise atleast your browser must support WebRTC and other latest standards and technologies required.
          </div>
        </article>
      </div>
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/components/BrowserNotSupported.js